import Hero from './components/Hero';
import About from './components/About';
import Approach from './components/Approach';
import Services from './components/Services';
import HomeProjects from './components/HomeProjects';
import Benefits from './components/Benefits';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen overflow-x-hidden">
      <Hero />
      <About />
      <Approach />
      <Services />
      <HomeProjects />
      <Benefits />
      <Footer />
    </div>
  );
}
